import React from "react";
import api from './../../../services/api';
import "./styles.css";
import { user_token } from '../../../services/Auth';
import "./styles.css";

import {agent} from '../../../services/api';
let apiAgent = new agent();

var token = localStorage.getItem(user_token);

export default class RI_ConsultasDetalhes extends React.Component {

  state = {
    exames: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    //const request = await api.get(`/user/${this.props.user_id}`, { headers: { 'x-access-token': token } });
    const request = await apiAgent.getUser(this.props.user_id);
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });

  };

  render() {
    return (
      <>

        {this.state.exames.map(details => (
          <>
            <div id="exam">
              <p id="RI-Title-Cadastro-Paciente">Identificação do Paciente: </p><p>{details.numericID}</p>
              <p id="RI-Title-Cadastro-Paciente">Paciente:</p><p>{details.name}</p>
              {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
                details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                  null}
              <p id="RI-Title-Cadastro-Paciente">Data de Nascimento: </p><p>{details.birth}</p>
              <p id="RI-Title-Cadastro-Paciente">CPF: </p><p>{details.cpf}</p>
            </div>
          </>
        ))}
      </>
    );
  }
}
